// Uncomment the initialization options as required. For advanced initialization options please refer to IBM MobileFirst Platform Foundation Knowledge Center
var wlInitOptions = {
  showIOS7StatusBar: false,
  logger: { enabled: true, level: 'warn', stringify: true, tag: { level: false, pkg: true }, whitelist: [], blacklist: [] }
};

var csxInitOptions = {
  offlineAuth: true,
  gotoLastPageBeforeLogin: false,
  authorization: {
    inclusive: {
      //if set to true user must be in all groups defined in groups for app access
      all: false,
      //user must be in these groups for app access
      groups: ['client.atam.eic']
    },
    exclusive: {
      //if set to true user must be in all groups defined in groups for no app access
      all: false,
      //user can not be in these groups for app access
      groups: []
    }
  }
};
